export default "__VITE_PUBLIC_ASSET__e275f2c7__"